import React from "react";
import { useNavigate } from "react-router-dom";
import { ContactUsLevelJourneyModel } from "./ContactUsLevelJourneyModel";

import "./ContactUsLevelJourney.css";

const ContactUsLevelJourney: React.FC<{ blok: ContactUsLevelJourneyModel }> = ({
  blok,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (blok.link?.cached_url) {
      if (blok.link?.linktype === "story") {
        navigate(`/${blok.link.cached_url}`);
      } else {
        const url = new URL(blok.link.cached_url, window.location.origin);
        window.location.href = url.href;
      }
    }
  };

  return (
    <div
      className="contact-us-level-journey"
      style={{ backgroundColor: blok.backgroundColor }}
      onClick={handleClick}
    >
      <div className="journey-title" title={blok.title}>
        {blok.title}
      </div>
      <div className="journey-description" title={blok.description}>
        {blok.description}
      </div>
    </div>
  );
};

export default ContactUsLevelJourney;
